export const projects = [
    {
      "id": "1",
      "name": "LaptopResalez.",
      "description": "LaptopResaleZ. website helps people to buy any second-hand product.",
      "image": "https://i.ibb.co/rprpfgx/resale.png",
      "live_link": "https://laptop-resale-8831b.web.app/",
      "github_client": "https://github.com/MehediAhsan/laptop-resale-client",
      "github_server": "https://github.com/MehediAhsan/laptop-resale-server"
    },
    {
      "id": "2",
      "name": "Tour Place",
      "description": "This website provide users to different types of hotel books.",
      "image": "https://i.ibb.co/PFKQPGD/tour.png",
      "live_link": "https://tour-place-cf5e6.web.app/",
      "github_client": "https://github.com/MehediAhsan/tour-place",
      "github_server": "https://github.com/MehediAhsan/tour-place-server"
    },
    {
      "id": "3",
      "name": "Swader Songe",
      "description": "This website provide users to different types of foods to book.",
      "image": "https://i.ibb.co/NmVfQWS/restaurant.png",
      "live_link": "https://swader-songe.vercel.app/",
      "github_client": "https://github.com/MehediAhsan/swader-songe-restaurant",
      "github_server": "https://github.com/MehediAhsan/swader-songe-restaurant"
    },
    {
      "id": "4",
      "name": "Ahsan Photography",
      "description": "This application provide in wedding, sports, portrait, event photography.",
      "image": "https://i.ibb.co/rG54G2q/ahsanphotography.png",
      "live_link": "https://ahsan-photography.web.app/",
      "github_client": "https://github.com/MehediAhsan/ahsan-photography-client",
      "github_server": "https://github.com/MehediAhsan/ahsan-photography-server"
    },  
    {
      "id": "4",
      "name": "eduConnect",
      "description": "This application provide educational courses and tutorials",
      "image": "https://i.ibb.co/VVpq7Px/educonnect.png",
      "live_link": "https://education-platform-eight.vercel.app/",
      "github_client": "https://github.com/MehediAhsan/education-platform",
      "github_server": "https://github.com/MehediAhsan/education-platform"
    }  
  ]